"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuitePrefixes = void 0;
var AuthSuitePrefixes;
(function (AuthSuitePrefixes) {
    AuthSuitePrefixes["LocalStoragePrefix"] = "auth-suite-";
})(AuthSuitePrefixes = exports.AuthSuitePrefixes || (exports.AuthSuitePrefixes = {}));
